export const GENRE_PRESETS = [
  'Cooking',
  "Children's Books",
  'Education',
  'Fiction',
  'Mystery',
  'Thriller',
  'Action',
  'Nonfiction',
  'Romance',
  'Fantasy'
]

export function normalizeGenre (genre) {
  if (!genre || typeof genre !== 'string') {
    return null
  }

  const normalized = genre.trim()
  const lowerNormalized = normalized.toLowerCase()

  for (const preset of GENRE_PRESETS) {
    if (preset.toLowerCase() === lowerNormalized) {
      return preset
    }
  }

  return normalized
}

export function formatGenres (genres) {
  if (!Array.isArray(genres)) {
    return []
  }

  return genres
    .map(normalizeGenre)
    .filter(genre => genre !== null)
    .filter((genre, index, self) => self.indexOf(genre) === index)
}

export function useGenreFormat () {
  return {
    normalizeGenre,
    formatGenres,
    GENRE_PRESETS
  }
}

